import Skeleton from "@/src/components/common/Skeleton";

const DateSkeleton = () => {
    return (
        <>
            <Skeleton
                variant="text"
                width="340px"
                height="16px"
                className="md:mb-3 md:mb-8 mb-4 mx-auto flex justify-center items-center"
            />
            <div className="flex flex-wrap justify-center gap-4">
                {Array.from({ length: 2 }).map((_, idx) => (
                    <div className="w-[145px]" key={idx}>
                        <div className="relative md:mb-6 mb-3 text-center flex items-center justify-center">
                            {idx === 0 && (
                                <Skeleton
                                    variant="rounded"
                                    width="24px"
                                    height="24px"
                                    className="absolute left-0"
                                />
                            )}

                            <div className="flex flex-col items-center justify-center">
                                <div className="mb-3">
                                    <Skeleton
                                        variant="text"
                                        width="80px"
                                        height="15px"
                                    />
                                </div>

                                <div className="mb-2">
                                    <Skeleton
                                        variant="text"
                                        width="61px"
                                        height="18px"
                                    />
                                </div>
                                <div className="text-sm font-medium text-gray-800">
                                    <Skeleton
                                        variant="text"
                                        width="44px"
                                        height="14px"
                                    />
                                </div>
                            </div>
                            {idx === 4 && (
                                <Skeleton
                                    variant="text"
                                    width="24px"
                                    height="24px"
                                    className="absolute right-0"
                                />
                            )}
                        </div>
                        <div className="flex flex-col gap-3 max-h-96 overflow-auto">
                            {Array.from({ length: 5 }).map((_, i) => (
                                <div key={i}>
                                    <Skeleton
                                        variant="text"
                                        width="145px"
                                        height="62px"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default DateSkeleton;
